/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ContracttypesQueryResponse } from '../../types/GetV1Contracttypes.ts'

export const getV1ContracttypesQueryKey = () => [{ url: '/v1/ContractTypes' }] as const

export type GetV1ContracttypesQueryKey = ReturnType<typeof getV1ContracttypesQueryKey>

/**
 * {@link /v1/ContractTypes}
 */
export async function getV1Contracttypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1ContracttypesQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/ContractTypes`, ...requestConfig },
    )
    return res
}

export function getV1ContracttypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ContracttypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ContracttypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ContracttypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Contracttypes(config)
        },
    })
}

/**
 * {@link /v1/ContractTypes}
 */
export function useGetV1Contracttypes<
    TData = ResponseConfig<GetV1ContracttypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ContracttypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ContracttypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ContracttypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ContracttypesQueryKey()

    const query = useQuery(
        {
            ...getV1ContracttypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
